import { REDUX } from "../../constants";

export const setAlertInfo = (alert) => {
  return { type: REDUX.ALERT_INFO,  alert};
};
export const hideAlert = () => {
  return { type: REDUX.HIDE_ALERT};
};